<template>
  <el-table-column
    prop="visit_time"
    sortable="custom"
    label="Látogatás"
    min-width="120"
  >
    <template slot-scope="scope">
      {{ scope.row.visit_time }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
